import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="book" className="relative bg-[#C8B4A4] text-brand-dark overflow-hidden" data-id="element-62">
      {/* Decorative dot pattern */}
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#3b2314 1.5px, transparent 1.5px)',
      backgroundSize: '28px 28px'
    }} data-id="element-63"></div>

      <div className="relative grid grid-cols-1 lg:grid-cols-2 items-stretch min-h-[640px]" data-id="element-64">
        {/* Left: CTA Content */}
        <div className="px-6 md:px-12 py-20 md:py-24 flex items-center justify-end" data-id="element-65">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full max-w-xl" data-id="element-66">
            <span className="uppercase tracking-widest text-sm font-extrabold text-brand-dark/80 mb-4 block" data-id="element-67">
              Let's take care of your Toyota.
            </span>
            <h2 className="font-heading uppercase tracking-wide text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 leading-[1.05]" data-id="element-68">
              Bring it in. See what we find.
            </h2>
            <p className="text-lg md:text-xl font-medium text-brand-dark/90 mb-10 leading-relaxed" data-id="element-69">
              Schedule a free inspection and get photos, video, and a
              plain-English breakdown of your Toyota's condition — before you
              approve a thing. No commitment, no pressure. Just a clear picture
              of where your car stands.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-70">
              <a href="tel:6512240267" className="w-full sm:w-auto px-8 py-4 bg-brand-dark hover:bg-gray-800 text-white text-lg font-bold rounded-md transition-colors shadow-2xl inline-flex justify-center items-center" data-id="element-71">
                Book Free Inspection
              </a>
              <a href="tel:6512240267" className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-brand-dark hover:bg-brand-dark/10 text-brand-dark text-lg font-bold rounded-md transition-colors flex items-center justify-center gap-2" data-id="element-72">
                Call (651) 224-0267
              </a>
            </div>

            <div className="bg-brand-dark/10 border border-brand-dark/20 rounded-xl px-5 py-4 inline-block" data-id="element-73">
              <p className="text-base md:text-lg font-bold text-brand-dark" data-id="element-74">
                You can also book online at{' '}
                <a href="https://lancerservice.com" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-brand-dark/80 transition-colors" data-id="element-75">
                  lancerservice.com
                </a>
              </p>
            </div>
          </motion.div>
        </div>

        {/* Right: Image — full-bleed to right viewport edge */}
        <motion.div initial={{
        opacity: 0,
        scale: 1.05
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9
      }} className="relative min-h-[320px] lg:min-h-full order-first lg:order-last" data-id="element-76">
          <img src="https://cdn.magicpatterns.com/uploads/cRSxQUteRxNCqyWUFaoLcQ/6.20.24Used-0316_Profile_RW_013.jpg" alt="ASE-certified Lancer technician inspecting under the hood" className="absolute inset-0 w-full h-full object-cover" data-id="element-77" />
          {/* Soft tan gradient bleeding into the left column */}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'linear-gradient(to right, #C8B4A4 0%, rgba(200,180,164,0.45) 20%, rgba(200,180,164,0) 50%)'
        }} data-id="element-78"></div>
          {/* Mobile gradient overlay from bottom for legibility separation */}
          <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-[#C8B4A4] lg:hidden" data-id="element-79" />
        </motion.div>
      </div>
    </section>;
}